export const DATA_ATTR = {
  // Dropdown
  DROPDOWN: "[data-dropdown]",
  DROPDOWN_TRIGGER: "[data-dropdown-trigger]",
  DROPDOWN_MENU: "[data-dropdown-menu]",
  DROPDOWN_ICON: "[data-dropdown-icon]",

  // Mobile Navigation
  MOBILE_NAV: "[data-mobile-nav]",
  MOBILE_NAV_TRIGGER: "[data-mobile-nav-trigger]",
  MOBILE_NAV_MENU: "[data-mobile-nav-menu]",
  MOBILE_NAV_ICON_OPEN: "[data-mobile-nav-icon-open]",
  MOBILE_NAV_ICON_CLOSE: "[data-mobile-nav-icon-close]",

  // Mobile Sidebar
  MOBILE_SIDEBAR: "[data-mobile-sidebar]",
  MOBILE_SIDEBAR_TRIGGER: "[data-mobile-sidebar-trigger]",
  MOBILE_SIDEBAR_PANEL: "[data-mobile-sidebar-panel]",
  MOBILE_SIDEBAR_ICON_OPEN: "[data-mobile-sidebar-icon-open]",
  MOBILE_SIDEBAR_ICON_CLOSE: "[data-mobile-sidebar-icon-close]",

  // Mobile Backdrop
  MOBILE_BACKDROP: "[data-mobile-backdrop]",

  // Tabs
  TABS: "[data-tabs]",

  // Colorpicker
  COLORPICKER: "[data-colorpicker]",
  COLORPICKER_TRIGGER: "[data-colorpicker-trigger]",

  // Elements
  GROUP_ID: "[data-group-id]",
  ELEMENT_ID: "[data-element-id]",

  // Skinini
  SKIN_INI: "[data-skin-ini]",

  // Actions
  CLEAR_SELECTION: "[data-clear-selection]",
  SET_TRANSPARENT: "[data-set-transparent]",
  RESET_INI: "[data-reset-ini]",
  IMPORT_INI: "[data-import-ini]",
  DOWNLOAD_INI: "[data-download-ini]",
  DOWNLOAD_ELEMENT: "[data-download-element]",
  FAVORITE_ELEMENT: "[data-favorite-element]",

  // Skin Page
  SKIN_REMIX: "[data-skin-remix]",
  SKIN_FAVORITE: "[data-skin-favorite]",
  SKIN_DOWNLOAD: "[data-skin-download]",
  SKIN_DOWNLOAD_PLACEHOLDER: "[data-skin-download-placeholder]",
  SKIN_DOWNLOAD_PLACEHOLDER_BACK: "[data-skin-download-placeholder-back]",
  SKIN_DOWNLOAD_STATUS: "[data-skin-download-status]",

  // Audio
  PLAY_BUTTON: "[data-play-button]",
  AUDIO_WAVEFORM: "[data-audio-waveform]",
  WAVEFORM_PROGRESS: "[data-waveform-progress]",

  // Project
  PROJECT_TOTAL: "[data-project-total]",
  PROJECT_CATEGORIES: "[data-project-categories]",
  PROJECT_DOWNLOAD: "[data-project-download]",
  PROJECT_RESET: "[data-project-reset]",
  PROJECT_SAVE: "[data-project-save]",
  PROJECT_NAME: "[data-project-name]",
  DOWNLOAD_PLACEHOLDER: "[data-download-placeholder]",
  DOWNLOAD_PLACEHOLDER_BACK: "[data-download-placeholder-back]",
  DOWNLOAD_STATUS: "[data-download-status]",
} as const;

export type DataAttribute = (typeof DATA_ATTR)[keyof typeof DATA_ATTR];
